<ng-container *ngIf="order?.indexStepActive === 3">
    <!-- DESKTOP -->
    <section class="edp-card-widget edp-widget-solar card desktop" (click)="redirectLinkDesk()">
        <img [src]="cardPushImageDesk" alt="Card App Solar" aria-hidden="true" />
        <h1 class="title">
            {{ "pt.edp.edponline.solar.card.widget.app.solar.title" | translate }}
        </h1>
        <div class="card-body">
            <p [innerHTML]="'pt.edp.edponline.solar.card.widget.app.solar.description' | translate"></p>
        </div>            
    </section>
    <!-- MOBILE -->
    <section class="edp-card-widget edp-widget-solar card mobile" (click)="redirectLinkMobile()">
        <img [src]="cardPushImageMobile" alt="Card App Solar" aria-hidden="true" />
        <div class="card-body">
            <h1 class="title">
                {{ "pt.edp.edponline.solar.card.widget.app.solar.title" | translate }}
            </h1>
            <p [innerHTML]="'pt.edp.edponline.solar.card.widget.app.solar.description' | translate"></p>
        </div>
    </section>
</ng-container>